<!-- <header class="mg-stellar-header mat-header">
    <img class="mg-logo" src="assets/images/mgo-logo-black.svg" alt="MoneyGram" />
    <div class="mg-back-close-container end">
      <button mat-icon-button
              [disableRipple]="true"
              (click)="closeCancelModal()"
              aria-label="close"
              color="primary"
              class="mg-back-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
</header> -->
<div class="contain-web-size">
  <div class="close-button-container">
    <img
      src="assets\images\close-black-icon.svg"
      alt="close-icon"
      (click)="closeCancelModal()"
    />
  </div>

  <div class="modal">
    <div class="modal-content">
      <app-locator-main
        [flow]="flow"
        [google]="google"
        [labels]="labels"
      ></app-locator-main>
    </div>
  </div>
</div>
<div class="contain-mobile-size">
  <!--TODO: This div should be removed (PENDING to decide what size should be accepted to mobile because sizes isMObile$ != #{$mg-lt-sm}) -->
  <app-locator-main
    [flow]="flow"
    [google]="google"
    [labels]="labels"
  ></app-locator-main>
</div>

<!-- <div class="mg-step-actions-row">
    <button color="primary" mat-raised-button (click)="closeModal()">{{labels.stellar.close}}</button>
</div> -->
